import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=e882fae6&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e882fae6')) {
      api.createRecord('e882fae6', component.options)
    } else {
      api.reload('e882fae6', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=e882fae6&", function () {
      api.rerender('e882fae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/FormPage.vue"
export default component.exports